import React from 'react'
import { Link } from 'react-router-dom'
import IconButtonUI from '../../../widgets/action/IconButtonUI'
import LRTableRowUI from '../../../widgets/layout/LRTableRowUI'
import LRTableBodyUI from '../../../widgets/layout/LRTableBodyUI'
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI'
import LoanPropertyListSF from '../../../components/superUser/loan/util/LoanPropertyListSF'
import BadgeUI from '../../../widgets/output/BadgeUI'

const DisbursementChecklistUI = ({ context, loan, loanBankAccount, onRefreshClick, onDownloadClick, downloadRequested }) =>
  <div className='c_disb_req'>
    <LRTableActionsUI location='top'
      left={
        <span className='g_flex_left g_flex_h'>
          <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} />
          <IconButtonUI icon='icon-download' onClick={onDownloadClick} />
          <span className='g_m_left_100 g_large'><b>Disbursement Checklist</b></span>
        </span>
      }
      right={<span />}
    />

    <LRTableBodyUI className='g_m_top_100'>
      <LRTableRowUI context={context} className='g_flex_top'
        left={<ProcFeeLeftUI loan={loan} />}
        right={<ProcFeeRightUI loan={loan} />}
      />

      <LRTableRowUI context={context} className='g_flex_top'
        left={<DSRALeftUI loan={loan} loanBankAccount={loanBankAccount} />}
        right={<DSRARightUI loan={loan} loanBankAccount={loanBankAccount} />}
      />

      <LRTableRowUI context={context} className='g_flex_top'
        left={<UseOfProceedsLeftUI loan={loan} />}
        right={<UseOfProceedsRightUI loan={loan} />}
      />

      <LRTableRowUI context={context} className='g_flex_top'
        left={<CPLeftUI loan={loan} />}
        right={<CPRightUI loan={loan} />}
      />
    </LRTableBodyUI>

    <LoanPropertyListSF context={context} loan={loan} category='disb_checklist' categoryLabel='Disbursement checklist tokens' />

  </div>

const ProcFeeLeftUI = ({ loan }) =>
  <span className='g_flex_v'>
    <span className='g_flex_h g_flex_left'>
      <b>Processing fee</b>
      {
        loan.termSheet.processingFeeFromLoan &&
        <BadgeUI className='g_m_left_100' label='from foan' />
      }
    </span>
    {
      loan.termSheet.processingFee1.amountWithoutTax > 0 &&
      <span>
        {loan.termSheet.processingFee1.amountWithTaxF2}
        <BadgeUI className='g_m_left_100' label={loan.procFee1Status} />
      </span>
    }
    <span>
      {loan.termSheet.processingFee2.amountWithTaxF2}
      <BadgeUI className='g_m_left_100' label={loan.procFee2Status} />
    </span>
  </span>

const ProcFeeRightUI = ({ loan }) =>
  <span className='g_m_left_100'>
    {
      loan.termSheet.processingFeeFromLoan ||
      (loan.termSheet.processingFee1.amountWithoutTax === 0 || loan.procFee1Status === 'paid' || loan.procFee1Status === 'waived') &&
      (loan.procFee2Status === 'paid' || loan.procFee2Status === 'waived') &&
      <span className='icon icon-check'></span>
    }
    {
      !loan.termSheet.processingFeeFromLoan &&
      (loan.termSheet.processingFee1.amountWithoutTax > 0 && (loan.procFee1Status === 'unpaid' || loan.procFee1Status === 'pending') ||
        (loan.procFee2Status === 'unpaid' || loan.procFee2Status === 'pending')) &&
      <span className='icon icon-times'></span>
    }
  </span>

const DSRALeftUI = ({ loan, loanBankAccount }) =>
  <span className='g_flex_v'>
    <span className='g_flex_h g_flex_left'>
      <b>DSRA</b>
      {
        loan.termSheet.dsraFromLoan &&
        <BadgeUI className='g_m_left_100' label='from foan' />
      }
    </span>
    <span>DSRA requirement: {loan.sanction.dsraAmountF2}</span>
    Available balance: {loanBankAccount ? loanBankAccount.availableBalanceF1 : ''}
  </span>

const DSRARightUI = ({ loan, loanBankAccount }) =>
  <span className='g_m_left_100'>
    {
      (loan.termSheet.dsraFromLoan ||
        loanBankAccount && loanBankAccount.availableBalance >= loan.sanction.dsraAmount) &&
      <span className='icon icon-check'></span>
    }
    {
      !loan.termSheet.dsraFromLoan &&
      loanBankAccount && loanBankAccount.availableBalance < loan.sanction.dsraAmount &&
      <span className='icon icon-times'></span>
    }
  </span>

const UseOfProceedsLeftUI = ({ loan }) =>
  <span className='g_flex_v'>
    <span className='g_flex_h g_flex_left'>
      <b>Use of proceeds</b>
    </span>
    <i>Use of proceeds with OTP entered will be shown here</i>
  </span>

const UseOfProceedsRightUI = ({ loan }) =>
  <span className='g_m_left_100'>
    {false && <span className='icon icon-check'></span>}
    {true && <span className='icon icon-times'></span>}
  </span>

const CPLeftUI = ({ loan }) =>
  <span className='g_flex_v'>
    <span className='g_flex_h g_flex_left'>
      <b><Link to={`/su/loans/${loan.loanId}/compliance/cp`}>Condition precedent</Link></b>
    </span>
    <span>
      <b>Not complied</b>:
      {
        loan.fileUploadList.filter(file => file.internalStatus === 'not_complied').map((file, i) =>
          <React.Fragment key={i}>
            {' '}{file.fileTitle}
            {i < loan.fileUploadList.length - 1 && ','}
          </React.Fragment>
        )
      }
    </span>
  </span>

const CPRightUI = ({ loan }) =>
  <span className='g_m_left_100'>
    {false && <span className='icon icon-check'></span>}
    {true && <span className='icon icon-times'></span>}
  </span>

export default DisbursementChecklistUI
